import { color } from "@smartsheet/design-tokens-react";
import { themed } from "@smartsheet/sds-theme-internal";
export const textAreaTheme = themed({
  // use with getStylingState in formInputTheme
  resizerOffset: {
    bottom: {
      rest: {
        "lodestar-light": "-2.25px",
        "ursa-light": "-2.25px"
      },
      error: {
        "lodestar-light": "-2.25px",
        "ursa-light": "-3.25px"
      },
      active: {
        "lodestar-light": "-2.25px",
        "ursa-light": "-3.25px"
      }
    },
    right: {
      rest: {
        "lodestar-light": "2px",
        "ursa-light": "2px"
      },
      error: {
        "lodestar-light": "2px",
        "ursa-light": "1px"
      },
      active: {
        "lodestar-light": "2px",
        "ursa-light": "1px"
      }
    }
  },
  resizerColor: {
    "lodestar-light": color("color--background--neutral--stronger"),
    "ursa-light": color("color--background--neutral--strongest")
  }
});
//# sourceMappingURL=textAreaTheme.js.map